import { getDefaultApi } from './ChinookApiService';

export const getDossierByUidEntreprise = (uidEntreprise) => getDefaultApi().searchDossierSouscription(uidEntreprise).then((response) => response.data);

export const mettreAjourParticipation = (uid, { valuesAenvoye }) =>
         getDefaultApi()
           .updateParticipation(uid, valuesAenvoye)
           .then((response) => response.data);

export const mettreAjourInteressement = (uid, { valuesAenvoye }) =>
         getDefaultApi()
           .updateInteressement(uid, valuesAenvoye)
           .then((response) => response.data);

export const mettreAjourPlanExistant = (uid, { valuesAenvoyer }) =>
         getDefaultApi()
           .updatePlanExistant(uid, valuesAenvoyer)
           .then((response) => response.data);

export const mettreAjourTarification = (uid, { valuesAenvoye }, { sauvegardeSeule } = {}) =>
         getDefaultApi()
           .updateTarification(uid, valuesAenvoye, sauvegardeSeule)
           .then((response) => response.data);

export const mettreAjourAbondements = (uid, { dispositifs }) =>
         getDefaultApi()
           .updateAbondements(uid, dispositifs)
           .then((response) => response.data);

export const sendKycFields = (uid, fields) =>
         getDefaultApi()
           .updateAnnexeKYC(uid, fields)
           .then((response) => response.data);

export const envoiEmailBulletinAvantSignature = (uid) =>
         getDefaultApi()
           .envoiMailAvantSignature(uid)
           .then((response) => response.data);
